import { pickLiveOrPreliveId, findFirstAvailableMarket } from "../../helpers";
export const prepareMarket = (markets, marketsConfig, isLive) => {
    const ids = marketsConfig.map(m => pickLiveOrPreliveId(m, isLive));
    return findFirstAvailableMarket(markets, ids);
};
//# sourceMappingURL=prepareMarket.js.map